import {
	Checkbox,
	FormControl,
	FormHelperText,
	FormLabel,
} from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { Controller, useFormContext } from "react-hook-form";
import {
	ICheckboxList,
} from "./CheckboxProps";
import { FnComponents, I18n } from "utilities/utilities";
import { I18NextNs, TypeComponent } from "enum/enum";

export const CheckBoxListItem = (props: ICheckboxList) => {
	const {
		label = "",
		name,
		disabled = false,
		required = false,
		style,
		options,
		IsShowMessageError = true,
		IsSelectAllOption = false,
		defaultValue = [],
		size = "small",
		row = true,
	} = props;

	const { control, register, setValue } = useFormContext();

	const SetValueController = (e, arrValue) => {
		let arrData = [];
		if (arrValue && Array.isArray(arrValue)) {
			if (e.target.checked) {
				
				arrValue.push(e.target.value);
			} else {
				arrValue = arrValue.filter((f) => f !== e.target.value);
			}
			arrData = arrValue;
		}	
		return arrData;
	};

	const CheckAll = (checked) => {
		let arrData = [];
		if (checked) {
			options.forEach((item) => {
				let disabled = item.disabled ?? false;
				if (!disabled) {
					arrData.push(item.value);
				}
			});
		}
		return arrData;
	};

	const CheckItem = (arrValue, item) => {
		let checked = false;
		if (arrValue && Array.isArray(arrValue) && item) {
			checked = arrValue.filter((f) => f === item.value).length > 0;
		}
		return checked;
	};

	return (
		<Controller
			name={name}
			control={control}
			rules={{ required: required }}
			shouldUnregister={true}
			defaultValue={defaultValue}
			render={({ field: { value, ref }, fieldState: { invalid } }) => {
				
				let IsValid = invalid && !disabled;
				let helperText = `${I18n.SetText("required", I18NextNs.validation)} ${label}`;
				let cbItem = options.filter((f) => !(f.disabled ?? false));
				let sValue = name + "-All";
				let sKeyItem = name + "-All";
				let sCheckAllId = FnComponents.GetId(TypeComponent.checkBox, sValue, name);
				let sCheckAllKey = FnComponents.GetKey(TypeComponent.checkBox, sKeyItem);
				return (
					<FormControl required={required} error={invalid} ref={ref}>
						{label && <FormLabel component="legend">{label}</FormLabel>}
						<FormGroup row={row} {...register(`${name}`)}>
							{IsSelectAllOption && (
								<FormControlLabel
									key={sCheckAllKey}
									control={
										<Checkbox
											id={sCheckAllId}
											checked={value.length === cbItem.length}
											disabled={disabled}
											onChange={(e) => {
												let arrAllItem = CheckAll(e.target.checked);
												
												setValue(name, arrAllItem, { shouldValidate: true });
												if (props.onChange) {
													props.onChange(arrAllItem);
												}
											}}
											style={style}
											size={size}
										/>
									}
									label={`เลือกทั้งหมด`}
									// label={`${I18n.SetText("CheckAll",I18NextNs.labelComponent)}`}
								/>
							)}
							{options.map((item, index) => {
								let label = item.label;
							
								let sKeyItem = name + "-" + index;
								let sValue = sKeyItem+"-"+item.value + "";
								let sID = FnComponents.GetId(TypeComponent.checkBox,sValue, sKeyItem);
								let sKey = FnComponents.GetKey(TypeComponent.checkBox, sKeyItem);
								let IsDisabled = disabled || (item.disabled ?? false);
								return (
									<FormControlLabel
										key={sKey}
										control={
											<Checkbox
												id={sID}
												disabled={IsDisabled}
												checked={CheckItem(value, item)}
												value={item.value}
												onChange={(e) => {
													let arrData = SetValueController(e, value);
													setValue(name, arrData, {
														shouldValidate: true,
														shouldDirty: true,
														shouldTouch: true,
													});
													if (props.onChange) {
														props.onChange(arrData);
													}
												}}
												style={style}
												size={size}
											/>
										}
										label={label}
									/>
								);
							})}
						</FormGroup>
						{IsShowMessageError && IsValid && (
							<FormHelperText>{helperText}</FormHelperText>
						)}
					</FormControl>
				);
			}}
		/>
	);
};